<template>
  <div class="verify-container d-flex justify-content-center align-items-center min-vh-100">
    <div class="verify-card shadow-lg p-4 rounded-4 text-center">
      <div class="mb-3">
        <span v-if="loading" class="verify-icon bg-primary bg-gradient text-white">
          <i class="bi bi-envelope-paper"></i>
        </span>
        <span v-else-if="success" class="verify-icon bg-success bg-gradient text-white">
          <i class="bi bi-check-circle"></i>
        </span>
        <span v-else-if="error" class="verify-icon bg-danger bg-gradient text-white">
          <i class="bi bi-x-circle"></i>
        </span>
      </div>
      <h3 class="mb-2">Email Verification</h3>
      <div v-if="loading" class="mb-2">
        <div class="spinner-border text-primary mb-2"></div>
        <div>Verifying your email…</div>
      </div>
      <div v-if="success" class="alert alert-success">{{ success }}</div>
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-if="!loading" class="mt-3">
        <router-link to="/login" class="btn btn-primary btn-lg px-4">Go to login</router-link>
      </div>
    </div>
  </div>
</template>
<style scoped>
.verify-container {
  background: linear-gradient(120deg, #f0f4ff 0%, #e0e7ff 100%);
  min-height: 100vh;
}
.verify-card {
  background: #fff;
  max-width: 400px;
  width: 100%;
  border-radius: 1.5rem;
  box-shadow: 0 8px 32px rgba(80, 120, 200, 0.12);
  margin: 2rem auto;
}
.verify-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  box-shadow: 0 2px 8px rgba(80, 120, 200, 0.10);
}
h3 {
  font-weight: 700;
  color: #2d3a5a;
}
.alert {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
.btn-primary {
  font-weight: 600;
  letter-spacing: 0.03em;
}
</style>

<script>
import { getFullUrl } from "@/services/signedUrlClient";

export default {
  data() {
    return {
      loading: true,
      success: null,
      error: null,
    };
  },
  async mounted() {
    const verifyUrlParam = this.$route.query.verify_url;

    if (!verifyUrlParam) {
      this.error = "Invalid verification link.";
      this.loading = false;
      return;
    }

    const verifyUrl = decodeURIComponent(verifyUrlParam);

    try {
      await getFullUrl(verifyUrl);
      this.success = "Email verified successfully. You can now sign in.";
      // optional redirect after 2 seconds
      setTimeout(() => this.$router.push("/login"), 2000);
    } catch (e) {
      this.error =
        e?.response?.data?.message ||
        "Verification link is invalid or has expired.";
    } finally {
      this.loading = false;
    }
  },
};
</script>
